"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Requester_1 = __importDefault(require("./Requester"));
var BlockedRequester = /** @class */ (function (_super) {
    __extends(BlockedRequester, _super);
    function BlockedRequester(baseUrl, logger, localStorage) {
        var _this = _super.call(this, baseUrl, logger) || this;
        _this.localStorage = localStorage;
        return _this;
    }
    BlockedRequester.prototype.getJson = function (path, query) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, _super.prototype.getResponse.call(this, path, query)];
                    case 1:
                        res = _a.sent();
                        this.blockUserIfNeeded(res);
                        return [2 /*return*/, res.json()];
                }
            });
        });
    };
    BlockedRequester.prototype.postJson = function (path, body, headers) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, _super.prototype.postResponse.call(this, path, body, headers)];
                    case 1:
                        res = _a.sent();
                        this.blockUserIfNeeded(res);
                        return [2 /*return*/, res.json()];
                }
            });
        });
    };
    BlockedRequester.prototype.blockUserIfNeeded = function (response) {
        if (response.status === 200) {
            this.localStorage.remove('blocked');
        }
        else if (response.status === 403) {
            this.localStorage.set('blocked', new Date().toISOString());
            throw new Error('Your grow account is disabled. Please remove your grow script.');
        }
    };
    return BlockedRequester;
}(Requester_1.default));
exports.default = BlockedRequester;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQmxvY2tlZFJlcXVlc3Rlci5qcyIsInNvdXJjZVJvb3QiOiJzcmMvIiwic291cmNlcyI6WyJzcmMvbGliL3NlcnZpY2VzL25ldHdvcmsvQmxvY2tlZFJlcXVlc3Rlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUVBLDBEQUFtQztBQUVuQztJQUE4QyxvQ0FBUztJQUduRCwwQkFBWSxPQUFlLEVBQUUsTUFBYyxFQUFFLFlBQTBCO1FBQXZFLFlBQ0ksa0JBQU0sT0FBTyxFQUFFLE1BQU0sQ0FBQyxTQUV6QjtRQURHLEtBQUksQ0FBQyxZQUFZLEdBQUcsWUFBWSxDQUFBOztJQUNwQyxDQUFDO0lBRUssa0NBQU8sR0FBYixVQUEyQyxJQUFZLEVBQUUsS0FBYTs7Ozs7NEJBQ3RELHFCQUFNLGlCQUFNLFdBQVcsWUFBQyxJQUFJLEVBQUUsS0FBSyxDQUFDLEVBQUE7O3dCQUExQyxHQUFHLEdBQUcsU0FBb0M7d0JBQ2hELElBQUksQ0FBQyxpQkFBaUIsQ0FBQyxHQUFHLENBQUMsQ0FBQTt3QkFDM0Isc0JBQU8sR0FBRyxDQUFDLElBQUksRUFBRSxFQUFBOzs7O0tBQ3BCO0lBRUssbUNBQVEsR0FBZCxVQUNJLElBQVksRUFDWixJQUE2QixFQUM3QixPQUFnQzs7Ozs7NEJBRXBCLHFCQUFNLGlCQUFNLFlBQVksWUFBQyxJQUFJLEVBQUUsSUFBSSxFQUFFLE9BQU8sQ0FBQyxFQUFBOzt3QkFBbkQsR0FBRyxHQUFHLFNBQTZDO3dCQUN6RCxJQUFJLENBQUMsaUJBQWlCLENBQUMsR0FBRyxDQUFDLENBQUE7d0JBQzNCLHNCQUFPLEdBQUcsQ0FBQyxJQUFJLEVBQUUsRUFBQTs7OztLQUNwQjtJQUVTLDRDQUFpQixHQUEzQixVQUE0QixRQUFrQjtRQUMxQyxJQUFJLFFBQVEsQ0FBQyxNQUFNLEtBQUssR0FBRyxFQUFFO1lBQ3pCLElBQUksQ0FBQyxZQUFZLENBQUMsTUFBTSxDQUFDLFNBQVMsQ0FBQyxDQUFBO1NBQ3RDO2FBQU0sSUFBSSxRQUFRLENBQUMsTUFBTSxLQUFLLEdBQUcsRUFBRTtZQUNoQyxJQUFJLENBQUMsWUFBWSxDQUFDLEdBQUcsQ0FBQyxTQUFTLEVBQUUsSUFBSSxJQUFJLEVBQUUsQ0FBQyxXQUFXLEVBQUUsQ0FBQyxDQUFBO1lBQzFELE1BQU0sSUFBSSxLQUFLLENBQUMsZ0VBQWdFLENBQUMsQ0FBQTtTQUNwRjtJQUNMLENBQUM7SUFDTCx1QkFBQztBQUFELENBQUMsQUFoQ0QsQ0FBOEMsbUJBQVMsR0FnQ3REIn0=